// the constants must be a 1-1 mapping with the corresponding Ruby file

export const FT = {
  AFTERCARE: 'aftercare',
  AI_ASSISTANT: 'ai_assistant',
  AFTERCARE_CUSTOMER_FEEDBACK: 'aftercare_customer_feedback',
  ANNOUNCEMENTS: 'announcements',
  CONVERSATION_AGENT: 'conversation_agent',
  CONVERSATION_MENTIONS: 'conversation_mentions',
  DECISIONS_CORE: 'decisions_core',
  DECISIONS_DOCUMENTS: 'decisions_documents',
  DECISIONS_FINANCIALS: 'decisions_financials',
  DECISIONS_FINANCIALS_EXTENDED: 'decisions_financials_extended',
  DECISIONS_PARTNERS: 'decisions_partners',
  DECISIONS_PROPOSALS_MULTIPLE_APPROVAL: 'decisions_proposals_multiple_approval',
  DECISIONS_REMINDERS: 'decisions_reminders',
  DECISIONS_TICKETS: 'decisions_tickets',
  DOCUMENT_CATEGORIES: 'document_categories',
  DOCUMENTS: 'documents',
  EMAIL_FORWARDING_CLIENT: 'email_forwarding_client',
  EMPLOYEE_CUSTOM_THEME: 'employee_custom_theme',
  EMPLOYEE_IMPORT_CUSTOMERS: 'employee_import_customers',
  EMPLOYEE_IMPORT_SPACES: 'employee_import_spaces',
  EMPLOYEE_IMPORT_UNITS: 'employee_import_units',
  FAQS: 'faqs',
  FINANCIALS: 'financials',
  FIREBASE_AUTH: 'firebase_auth',
  INFORMATION_FULL: 'information_full',
  INSPIRATIONS: 'inspirations',
  MOBILE_APP_CUSTOMER: 'mobile_app_customer',
  MULTILINGUAL: 'multilingual',
  MULTILINGUAL_ANNOUNCEMENTS: 'multilingual_announcements',
  PROJECT_PARTNERS: 'project_partners',
  PROJECT_SUBDOMAINS: 'project_subdomains',
  PROPOSAL_CHOICE_LISTS: 'proposal_choice_lists',
  PROPOSAL_TEMPLATES: 'proposal_templates',
  SALES: 'sales',
  SNIPPETS: 'snippets',
  SURVEYS: 'surveys',
  TASKS: 'tasks',
  TEMPLATE_PROJECTS: 'template_projects',
  TICKETS: 'tickets',
  TODOS: 'todos',
  WORKFLOWS_FULL: 'workflows_full',
  WORKFLOWS_PHASES: 'workflows_phases',
  WORKFLOWS_TASKS: 'workflows_tasks',
};

export const FEATURES_CLIENT = [
  FT.AFTERCARE,
  FT.AFTERCARE_CUSTOMER_FEEDBACK,
  FT.AI_ASSISTANT,
  FT.ANNOUNCEMENTS,
  FT.CONVERSATION_AGENT,
  FT.CONVERSATION_MENTIONS,
  FT.DECISIONS_CORE,
  FT.DECISIONS_DOCUMENTS,
  FT.DECISIONS_FINANCIALS,
  FT.DECISIONS_FINANCIALS_EXTENDED,
  FT.DECISIONS_PARTNERS,
  FT.DECISIONS_PROPOSALS_MULTIPLE_APPROVAL,
  FT.DECISIONS_REMINDERS,
  FT.DECISIONS_TICKETS,
  FT.DOCUMENTS,
  FT.DOCUMENT_CATEGORIES,
  FT.EMAIL_FORWARDING_CLIENT,
  FT.EMPLOYEE_CUSTOM_THEME,
  FT.EMPLOYEE_IMPORT_CUSTOMERS,
  FT.EMPLOYEE_IMPORT_SPACES,
  FT.EMPLOYEE_IMPORT_UNITS,
  FT.FAQS,
  FT.FINANCIALS,
  FT.INFORMATION_FULL,
  FT.INSPIRATIONS,
  FT.MOBILE_APP_CUSTOMER,
  FT.MULTILINGUAL,
  FT.MULTILINGUAL_ANNOUNCEMENTS,
  FT.PROJECT_PARTNERS,
  FT.PROJECT_SUBDOMAINS,
  FT.PROPOSAL_CHOICE_LISTS,
  FT.PROPOSAL_TEMPLATES,
  FT.SALES,
  FT.SNIPPETS,
  FT.SURVEYS,
  FT.TASKS,
  FT.TEMPLATE_PROJECTS,
  FT.TICKETS,
  FT.TODOS,
  FT.WORKFLOWS_FULL,
  FT.WORKFLOWS_PHASES,
  FT.WORKFLOWS_TASKS,
];

export const TIER_CORE_SUP = 'core_sup';
export const TIER_PRO_SUP = 'pro_sup';
export const TIER_PLUS_SUP = 'plus_sup';
export const TIER_ENTERPRISE_SUP = 'enterprise_sup';
export const TIER_ESSENTIAL_MUP = 'essential_mup';
export const TIER_COMPLETE_MUP = 'complete_mup';
export const TIER_ENTERPRISE_MUP = 'enterprise_mup';

export const TIERS = [
  TIER_CORE_SUP,
  TIER_PRO_SUP,
  TIER_PLUS_SUP,
  TIER_ENTERPRISE_SUP,
  TIER_ESSENTIAL_MUP,
  TIER_COMPLETE_MUP,
  TIER_ENTERPRISE_MUP,
];

// Cheapest first: every tier includes the tiers before it.
export const TIERS_SUP = [TIER_CORE_SUP, TIER_PRO_SUP, TIER_PLUS_SUP, TIER_ENTERPRISE_SUP];
export const TIERS_MUP = [TIER_ESSENTIAL_MUP, TIER_COMPLETE_MUP, TIER_ENTERPRISE_MUP];

export const TIER_LABELS = {
  [TIER_CORE_SUP]: 'Core',
  [TIER_PRO_SUP]: 'Pro',
  [TIER_PLUS_SUP]: 'Plus',
  [TIER_ENTERPRISE_SUP]: 'Enterprise',
  [TIER_ESSENTIAL_MUP]: 'Essential',
  [TIER_COMPLETE_MUP]: 'Complete',
  [TIER_ENTERPRISE_MUP]: 'Enterprise',
};

export const TIERS_BY_PROJECT_TYPE = {
  sup: TIERS_SUP,
  mup: TIERS_MUP,
};

export function tierOptions(project_type) {
  return TIERS_BY_PROJECT_TYPE[project_type].map((value) => ({ value, label: TIER_LABELS[value] }));
}

export function isFeatureInTier(feature, project_type, tier) {
  const tiers = TIERS_BY_PROJECT_TYPE[project_type];
  const index_entry = tiers.indexOf(FEATURE_TIERS[feature][project_type]);
  return index_entry !== -1 && tiers.indexOf(tier) >= index_entry;
}

export const FEATURE_TIERS = {
  [FT.TICKETS]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.CONVERSATION_MENTIONS]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  // every plan offers it while it is free (until 31/12/2026); a client uses it once an owner agreed (ENG-4320)
  [FT.CONVERSATION_AGENT]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.SNIPPETS]: { sup: TIER_PLUS_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.DOCUMENTS]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.DOCUMENT_CATEGORIES]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.ANNOUNCEMENTS]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.FAQS]: { sup: TIER_PRO_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.EMAIL_FORWARDING_CLIENT]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.DECISIONS_CORE]: { sup: TIER_PRO_SUP, mup: TIER_ESSENTIAL_MUP },
  // Sold from Plus and Complete, so merging this into decisions_core would give it away early.
  [FT.DECISIONS_FINANCIALS]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.DECISIONS_TICKETS]: { sup: TIER_PRO_SUP, mup: TIER_COMPLETE_MUP },
  [FT.DECISIONS_REMINDERS]: { sup: TIER_PRO_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.DECISIONS_PROPOSALS_MULTIPLE_APPROVAL]: { sup: TIER_PRO_SUP, mup: TIER_COMPLETE_MUP },
  [FT.PROPOSAL_TEMPLATES]: { sup: TIER_PRO_SUP, mup: TIER_COMPLETE_MUP },
  [FT.DECISIONS_DOCUMENTS]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.PROPOSAL_CHOICE_LISTS]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.DECISIONS_FINANCIALS_EXTENDED]: { sup: TIER_ENTERPRISE_SUP, mup: TIER_COMPLETE_MUP },
  [FT.WORKFLOWS_PHASES]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.WORKFLOWS_TASKS]: { sup: TIER_PRO_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.WORKFLOWS_FULL]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.TASKS]: { sup: TIER_PRO_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.AFTERCARE]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.AFTERCARE_CUSTOMER_FEEDBACK]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.FINANCIALS]: { sup: TIER_PLUS_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.SURVEYS]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.INSPIRATIONS]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.PROJECT_PARTNERS]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.DECISIONS_PARTNERS]: { sup: TIER_PLUS_SUP, mup: TIER_COMPLETE_MUP },
  [FT.TEMPLATE_PROJECTS]: { sup: TIER_CORE_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.PROJECT_SUBDOMAINS]: { sup: TIER_ENTERPRISE_SUP, mup: TIER_ENTERPRISE_MUP },
  [FT.MOBILE_APP_CUSTOMER]: { sup: TIER_PRO_SUP, mup: TIER_ESSENTIAL_MUP },
  [FT.INFORMATION_FULL]: { sup: null, mup: TIER_ESSENTIAL_MUP },
  [FT.MULTILINGUAL]: { sup: TIER_ENTERPRISE_SUP, mup: TIER_ENTERPRISE_MUP },
};

// The subscription screen's grouping and order of FEATURE_TIERS. Each group runs from the cheapest tier up.
export const FEATURE_GROUPS = [
  { name: 'conversations', features: [FT.TICKETS, FT.CONVERSATION_MENTIONS, FT.CONVERSATION_AGENT, FT.SNIPPETS] },
  { name: 'documents', features: [FT.DOCUMENTS, FT.DOCUMENT_CATEGORIES] },
  { name: 'announcements', features: [FT.ANNOUNCEMENTS] },
  { name: 'faqs', features: [FT.FAQS] },
  { name: 'email_forwarding', features: [FT.EMAIL_FORWARDING_CLIENT] },
  {
    name: 'decisions',
    features: [
      FT.DECISIONS_CORE,
      FT.DECISIONS_REMINDERS,
      FT.DECISIONS_TICKETS,
      FT.DECISIONS_PROPOSALS_MULTIPLE_APPROVAL,
      FT.PROPOSAL_TEMPLATES,
      FT.DECISIONS_DOCUMENTS,
      FT.PROPOSAL_CHOICE_LISTS,
      FT.DECISIONS_FINANCIALS,
      FT.DECISIONS_FINANCIALS_EXTENDED,
    ],
  },
  { name: 'workflows', features: [FT.WORKFLOWS_PHASES, FT.WORKFLOWS_TASKS, FT.WORKFLOWS_FULL] },
  { name: 'tasks', features: [FT.TASKS] },
  { name: 'aftercare', features: [FT.AFTERCARE, FT.AFTERCARE_CUSTOMER_FEEDBACK] },
  { name: 'financials', features: [FT.FINANCIALS] },
  { name: 'surveys', features: [FT.SURVEYS] },
  { name: 'inspirations', features: [FT.INSPIRATIONS] },
  { name: 'partner_portal', features: [FT.PROJECT_PARTNERS, FT.DECISIONS_PARTNERS] },
  { name: 'projects', features: [FT.TEMPLATE_PROJECTS, FT.PROJECT_SUBDOMAINS] },
  { name: 'customer_pwa', features: [FT.MOBILE_APP_CUSTOMER] },
  { name: 'property_development', features: [FT.INFORMATION_FULL] },
  { name: 'localization', features: [FT.MULTILINGUAL] },
];

// Sold in a tier but not built yet. This list only labels the row and locks its switch; what keeps
// the feature off everywhere is its kill_<feature> flag, which the API checks last.
export const FEATURES_NOT_BUILT = [];

export const FEATURES_UNDER_CONSTRUCTION = [FT.AI_ASSISTANT];

export const FEATURES_INTERNAL = [
  FT.EMPLOYEE_CUSTOM_THEME,
  FT.EMPLOYEE_IMPORT_CUSTOMERS,
  FT.EMPLOYEE_IMPORT_SPACES,
  FT.EMPLOYEE_IMPORT_UNITS,
  // Existing clients still use these; they are not sold any more.
  FT.MULTILINGUAL_ANNOUNCEMENTS,
  FT.SALES,
];

export const FEATURES_SUNSET = [FT.FIREBASE_AUTH, FT.TODOS];

// Decimal bytes, like clients.storage_sum_max. null: agreed per account.
export const STORAGE_BY_TIER = {
  sup: {
    [TIER_CORE_SUP]: 100_000_000_000,
    [TIER_PRO_SUP]: 1_000_000_000_000,
    [TIER_PLUS_SUP]: 2_000_000_000_000,
    [TIER_ENTERPRISE_SUP]: null,
  },
  mup: {
    [TIER_ESSENTIAL_MUP]: 250_000_000_000,
    [TIER_COMPLETE_MUP]: 2_000_000_000_000,
    [TIER_ENTERPRISE_MUP]: null,
  },
};
